// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"au-z","breadcrumbForward":"bu-z","breadcrumbBack":"cu-z","selected":"du-z"};